import { render, staticRenderFns } from "./EventCertificationList.vue?vue&type=template&id=5818af40&scoped=true&"
import script from "./EventCertificationList.vue?vue&type=script&lang=js&"
export * from "./EventCertificationList.vue?vue&type=script&lang=js&"
import style0 from "./EventCertificationList.vue?vue&type=style&index=0&id=5818af40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5818af40",
  null
  
)

export default component.exports